import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	nameLabel: {
		id: 'snippets.snippetEditorModal.nameLabel',
		defaultMessage: 'Template Name',
		description: 'Label for the template name input',
	},
	namePlaceholder: {
		id: 'snippets.snippetEditorModal.namePlaceholder',
		defaultMessage: 'Enter template name',
		description: 'Placeholder for the template name input',
	},
	nameError: {
		id: 'snippets.snippetEditorModal.nameError',
		defaultMessage: 'Name is required',
		description: 'Error message for the template name input',
	},
	descriptionLabel: {
		id: 'snippets.snippetEditorModal.descriptionLabel',
		defaultMessage: 'Description',
		description: 'Description label for the modal',
	},
	descriptionPlaceholder: {
		id: 'snippets.snippetEditorModal.descriptionPlaceholder',
		defaultMessage: 'Enter template description',
		description: 'Placeholder for the description input',
	},
	saveToLabel: {
		id: 'snippets.snippetEditorModal.saveToLabel',
		defaultMessage: 'Save to',
		description: 'Label for the Save to field (Personal/Site wide)',
	},
	adfError: {
		id: 'snippets.snippetEditorModal.adfError',
		defaultMessage: 'Something went wrong, please make a new content selection',
		description: 'Error message for when the selected ADF is invalid',
	},
	cancelButton: {
		id: 'snippets.snippetEditorModal.cancelButton',
		defaultMessage: 'Cancel',
		description:
			'Label on the cancel button in the block template editor modal that closes the modal without saving changes',
	},
	contentTooLargeFlagTitle: {
		id: 'snippets.snippetEditorModal.contentTooLargeFlagTitle',
		defaultMessage: 'Template content is too large',
		description:
			'Title for the error flag shown when template save fails due to content size limit',
	},
	contentTooLargeFlagDescription: {
		id: 'snippets.snippetEditorModal.contentTooLargeFlagDescription',
		defaultMessage: 'Reduce the content size and try again',
		description:
			'Description for the error flag shown when template save fails due to content size limit',
	},
	successFlagViewTemplateAction: {
		id: 'snippets.snippetEditorModal.successFlagViewTemplateAction',
		defaultMessage: 'View template',
		description:
			'Label for the action button in the success flag that opens the block templates panel',
	},
	successFlagDescription: {
		id: 'snippets.snippetEditorModal.successFlagDescription',
		defaultMessage: 'You can now use it from the / menu',
		description: 'Description text in the success flag shown after saving a template',
	},
});
